<template>
  <Head :title="institution.name" />
  <s-page-block>
    <s-page-header :heading="institution.name" class="mb-4">
      <template #actions>
        <super-admin-button :href="route('admin.institutions.show', route().params)" />
      </template>
    </s-page-header>
    <section
      :aria-label="t('institutionResources')"
      class="grid grid-cols-[repeat(auto-fill,_minmax(9rem,_1fr))] gap-2"
    >
      <s-card-btn
        v-if="can.viewCourses"
        :href="route('institutions.courses.index', route().params)"
        icon="book"
      >
        {{ $t('courses') }}
      </s-card-btn>
      <s-card-btn
        v-if="can.viewStaff"
        :href="route('institutions.staff.index', route().params)"
        icon="account"
      >
        {{ t('staff') }}
      </s-card-btn>
      <s-card-btn
        v-if="can.viewLtiRegistrations"
        :href="route('institutions.lti-platform-registrations.index', route().params)"
        icon="lock"
      >
        {{ t('lti') }}
      </s-card-btn>
    </section>
  </s-page-block>
</template>
<script setup lang="ts">
import SPageBlock from '../../design-system/SPageBlock.vue';
import SPageHeader from '../../design-system/SPageHeader.vue';
import {Institution} from '../../types/entities/institution';
import SuperAdminButton from '../../buttons/SuperAdminButton.vue';
import SBtn from '../../design-system/SBtn.vue';
import {route} from 'ziggy-js';
import SCardBtn from '../../design-system/SCardBtn.vue';
import {useI18n} from 'vue-i18n';
import {Head} from '@inertiajs/vue3';

defineProps<{
  institution: Institution;
  can: {
    update: boolean;
    viewCourses: boolean;
    viewStaff: boolean;
    viewLtiRegistrations: boolean;
  };
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "lti": "LTI",
    "staff": "Staff",
    "institutionResources": "Institution Resources"
  },
  "fr": {
    "lti": "LTI",
    "staff": "Personnel",
    "institutionResources": "Ressources de l'institution"
  }
}
</i18n>
